import { Component, ElementRef, HostListener, Injector, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import * as CryptoJS from 'crypto-js';
import { Loginservices } from './login.services';
import { DialogService } from 'primeng/dynamicdialog';
import { LoginsecuritymodalComponent } from '../views/directives/loginsecuritymodal/loginsecuritymodal.component';
import { SupportverificationcationmodalComponent } from '../views/directives/supportverificationcationmodal/supportverificationcationmodal.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { CaptchaComponent } from '../views/directives/captcha/captcha.component';
import { OtpInputComponent } from '../views/directives/otp-input/otp-input.component';
import { ResetpageComponent } from '../resetpage/resetpage.component';
import { ChangepasswordComponent } from '../changepassword/changepassword.component';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { Utilityservice } from '../views/utility/utilityservice.service';
import { BaseClass } from '../views/utility/baseClass';
import { ChanagepasswordwithOTPComponent } from '../chanagepasswordwith-otp/chanagepasswordwithOTP.component';
import { Password } from 'primeng/password';
import { BehaviorSubject, timer } from 'rxjs';
import { waitForAsync } from '@angular/core/testing';




@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent extends BaseClass implements OnInit {
  @ViewChild('userEmailInput') userEmailInput!: ElementRef;
  value: string = '';
  togglemsk: boolean = true;
  loginForm: FormGroup;
  userdata: any;
  ssoredirectlink: any;
  ssolinkmetadata: any;
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;
  @HostListener('document:click')
  @HostListener('document:keydown')
  resetTimer() {
    this.idle.watch();
  }
  constructor(private loginservice: Loginservices, public dialogService: DialogService,
    private fb: FormBuilder, private spinnerservice: NgxSpinnerService, private idle: Idle,
    private utilityservice: Utilityservice, public override injector: Injector,private activateroute:ActivatedRoute,
    private ngZone: NgZone

  ) {

    super(injector)
  // this.activateroute.queryParams.subscribe(params => {
  //   console.log(params['email']); // test@gmail.com
  //   if(params['email']!==undefined){
  //     console.log("not undefined");
      
  //   }else{
  //     console.log(undefined);
      
  //   }
  // });  
    this.idle.setIdle(1800); //30 minute

    // after idle, wait 30 sec then timeout
    this.idle.setTimeout(30);

    // detect click, scroll, keypress, touch
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.idle.onTimeout.subscribe(() => {
      this.showTimeoutSwal();
    });

    this.resetIdleTimer();


  }
  isssologin=false
  ngOnInit(): void {
      const email = this.activateroute.snapshot.queryParamMap.get('param');
    this.resetIdleTimer();
    this.loginFormInitial();
    this.gettrainingmsg();  
    this.getsessiontoken();
    this.getdynamiclogo();

     if (email) {
    console.log('Param exists:', email);
    this.isssologin=true;
    this.ssologin();
  }
  }
  public validation_message = {
    'useremail': [
    { type: 'required', message: 'Please enter your Email Address' },
    { type: 'maxlength', message: 'Maximum length exceeded'}
  ],'userpassword': [
    { type: 'required', message: 'Please enter Password' },
    { type: 'maxlength', message: 'Maximum length exceeded'}
  ],
  }
trainingannouncementmsg='';
sessiontoken='';
  showPassword = false;
  private sessiondata = new BehaviorSubject<any>(null)
defaultLogo = 'https://pbcomplinity.s3.ap-south-1.amazonaws.com/images/logo.png'; // your fallback logo
logoUrl = this.defaultLogo;
logoWidth = '220px'; // default width
isanotherorg:boolean=false
authenticationtype=""
loginformhide=false
  getdynamiclogo(){
          const email = this.activateroute.snapshot.queryParamMap.get('param');

    const paylaod={"subdomain":window.location.hostname.split('.')[0]}
    this.utilityservice.checkorginitial(paylaod).subscribe(res=>{
   console.log(res,"ress");
   
     if (res && res.length > 0) {
    const data = res[0];
    this.isanotherorg=true;

    this.logoUrl = data.logourl
      ? 'https://pbcomplinity.s3.ap-south-1.amazonaws.com/' + data.logourl
      : this.defaultLogo;

    this.logoWidth = data.logowidth ? data.logowidth + 'px' : '180px';
    this.ssoredirectlink=data.redirectlink;
    this.ssolinkmetadata=data.linkmetadata;
    this.authenticationtype=data.authenticationtype;
    if(this.authenticationtype=="DB"){
this.ssoenable=false
    }else{
      this.ssoenable=false
      this.loginForm.reset();
      this.loginForm.disable();
      if(!email){
      this.ssologinredirect();
      }

    }
    if(!email){
    const host = window.location.hostname.split('.')[0];
    this.redirect(host);
  }
  } else {
    this.isanotherorg=false;
    this.ssoenable=true;
    // fallback if no API data
    this.logoUrl = this.defaultLogo;
    this.logoWidth = '220px';
    this.ssoredirectlink='';
    this.ssolinkmetadata='';
  }
   
    })
  }
togglePassword() {
  this.showPassword = !this.showPassword;
}
  gettrainingmsg(){
    this.loginservice.trainingmsg().subscribe(res=>{
if(res.length>0){
      console.log(res,"res");
      this.trainingannouncementmsg=res[0].messagename;}
      
    })
  }
 getsessiontoken() {
  this.loginservice.sessiontoken().subscribe({
    next: (res: any) => {
      console.log(res);

      if (res?.response?.length > 0) {
        this.sessiontoken = res.response[0].pagetoken;

        localStorage.setItem('pagetoken', this.sessiontoken);
        this.sessiondata.next(this.sessiontoken);

        console.log('Token:', this.sessiontoken);
      }
    },
    error: (err) => {
      console.error('Error fetching token', err);
    }
  });
}

  loginFormInitial() {
    this.loginForm = this.fb.group({
      useremail: ['', Validators.compose([Validators.required,Validators.maxLength(50)])],
      userpassword: ['', Validators.compose([Validators.required,Validators.maxLength(50)])],
      privacypolicy: [false, Validators.compose([Validators.required])],
      termCondition: [false, Validators.compose([Validators.required])],
    })
  }

  checkValidation(): boolean {
    if (this.loginForm.get('useremail').value !== '' && this.loginForm.get('userpassword').value !== '') {
      return false
    } else {
      return true
    }
  }
  autoFill = {
  email: '',
  password: ''
};


  ngAfterViewInit() {
//     setTimeout(()=>{
//       console.log(this.autoFill,"auofill");
      
//     },500)
//       setTimeout(() => {
//     const inputs = document.querySelectorAll('input');
// console.log(inputs);

//     inputs.forEach((input: any) => {
//       console.log(input,"input");
      
//       // force browser to commit autofill value
//       input.dispatchEvent(new Event('input', { bubbles: true }));
//     });
//      document.addEventListener('animationstart', (event: any) => {
//       console.log(event);
      
//     if (event.animationName === 'autofill') {

//       const email = (document.querySelector('input[formControlName="useremail"]') as HTMLInputElement)?.value;
//       const password = (document.querySelector('input[formControlName="userpassword"]') as HTMLInputElement)?.value;
//   console.log(email,"email");
  
//       this.loginForm.patchValue({
//         useremail:email,
//         userpassword: password
//       });

//       this.loginForm.updateValueAndValidity();
//     }
//   });
//   }, 700);
// this.handleAutofill()
  
}
 handleAutofill(): void {
    setTimeout(() => {
      if (this.loginForm.value.email && this.loginForm.value.nativeElement) {
        const emailValue = this.loginForm.value.email.nativeElement.value;
        if (emailValue) {
          this.loginForm.get('email')?.setValue(emailValue);
        }
      }

      // if (this.passwordInput && this.passwordInput.nativeElement) {
      //   const passwordValue = this.passwordInput.nativeElement.value;
      //   if (passwordValue) {
      //     this.loginForm.get('password')?.setValue(passwordValue);
      //   }
      // }
    });
  }

  login() {
      // const email = this.activateroute.snapshot.queryParamMap.get('email');    
    if (this.loginForm.invalid) {
      this.validateAllFormFields(this.loginForm)
      return
    }
    else {
      let payload={}
      if(this.isssologin){
   payload = {
        userid: this.activateroute.snapshot.queryParamMap.get('param'), password: "", "isadauth": "SSO",
        "isssologin": "ssoxlogin","newlogin": "Y","pagetoken":this.sessiontoken
      }
      }
       else{payload = {
        userid: this.loginForm.get('useremail').value, password: this.loginForm.get('userpassword').value, "isadauth": "DB",
        "isssologin": "","newlogin": "N","pagetoken":this.sessiontoken

      }}
      const encryptdata = this.utilityservice.encryptData(payload);
      this.spinnerservice.show()
      this.loginservice.doLogin(encryptdata).subscribe(res => {
        this.spinnerservice.hide()

        if (res && res.response == 'success') {
          const result = res.userdata
          if (res.userdata.issupportadmin == 'Y') {
            Swal.fire({
              title: "It seems you are logging as Support Admin",
              text: 'To do the above, we alse require your real userid & password for security reasons.',
              showCancelButton: true,
              confirmButtonText: "Login",
              confirmButtonColor: 'rgb(221, 107, 85)',
              cancelButtonColor: 'grey',
              cancelButtonText: 'Cancel',
              icon: 'info',
              iconColor: 'rgb(221, 107, 85)'
            }).then((value) => {
              if (value.isConfirmed) {
                const ref = this.dialogService.open(SupportverificationcationmodalComponent, {
                  header: "Logged in  Security Information",
                  height: 'auto',
                  width: '50%',
                  data: { logindata: res.userdata }
                })
              }
            })

          }
          else if (res.userdata.ismfaenabled == 'Y') {
            this.openOtpwindow(res.userdata)
          }
          else {
           
            const ref = this.dialogService.open(LoginsecuritymodalComponent, {
              header: "Logged in  Security Information",
              style: { 
    width: '90vw', 
    'max-width': '800px' 
  },
    styleClass: 'scroll-dialog',

              data: { loginid: res.userdata.userid,email :this.loginForm.get('useremail').value}
            })
            ref.onClose.subscribe(() => {
              const data = JSON.stringify(res.userdata);
              localStorage.setItem('userdata', data);
              const loginTime = new Date().toISOString(); // or just new Date()
              localStorage.setItem('loginTime', loginTime);
              window.location.href = location.origin + res.userdata.defaultpagemircroservice + "#/"
            });

          }

        }
        // condition based swal message  ---11-02-2025
        else if (res.response == 'organisationsuspended') {
          Swal.fire({
            icon: "warning",
            title: "Your organisation's license is temporarily suspended. Please contact your organisation Administrator or Complinity Support.",
          });

        }
        else if (res.response == 'organisationsuspended') {
          `${this.loginForm.get('useremail').value} is already logged in from the same account`
          Swal.fire({
            icon: "warning",
            title: `${this.loginForm.get('useremail').value} is already logged in from the same account`,
          });
        }
        else if (res.response == 'multiplelogin') {
          Swal.fire({
            text: "This could be because you have closed the browser without logging out or internet connection broke while using the application. Kindly click Send OTP (One Time Password) button to receive email. Enter OTP to login (in popup screen) else account will be automatically enabled after 30 minutes.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Send OTP',
            cancelButtonText: "No, cancel it!",

          });
        }

        else if (res.response == 'loggedinothertab') {
          Swal.fire({
            text: "You are already using Complinity in other Tab of the browser.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Yes',
            cancelButtonText: "No, cancel it!",

          }).then((result)=>{

            if(result.isConfirmed){
             // this.utilityservice.logoutAndRedirect();
              payload = {
              userid: this.loginForm.get('useremail').value, password: this.loginForm.get('userpassword').value, "isadauth": "DB",
              "isssologin": "","newlogin": "Y","pagetoken":this.sessiontoken}
              this.relogin(payload);
            }
          })
        }

        else if (res.response == 'idlelogin') {
           Swal.fire({
      title: 'This screen is idle for more than 30 minutes, Please login again.',
      html: 'No activity detected.',
      icon: 'warning',
      confirmButtonText: 'OK',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: true,

    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload(); // refresh only on OK
      }
    });
        }


        else if (res.response == 'locked') {

          this.loginservice.getadmindetailsforcontact({
            emailaddress: this.loginForm.value.useremail
          }).subscribe(apiRes => {

            let contactHtml = '';
            if (apiRes && apiRes.length > 0) {
              contactHtml = `
        <p style="margin-top:15px;">
          Contact <b>${apiRes[0].firstname} ${apiRes[0].lastname}</b> 
          at <b>${apiRes[0].emailaddr}</b>
        </p>
      `;
            }

            Swal.fire({
              icon: "warning",
              html: `
        <div style="text-align:center; font-size:15px;">
          <p>
            <b>Security information :</b> Your login has failed more than the allowed maximum limit. 
            Your account is now locked. Please contact your Administrator to unlock it.
          </p>

          ${contactHtml}

          <p style="margin-top:10px;">
          You can also contact <b>Subhashree Panda</b><br>
          (subhashree.panda@complinity.com) at Complinity</p>
        </div>
      `
            });

          });
        }

        else if (res.response == '3monthlock') {

          this.loginservice.getadmindetailsforcontact({
            emailaddress: this.loginForm.value.useremail
          }).subscribe(apiRes => {

            let contactHtml = '';
            if (apiRes && apiRes.length > 0) {
              contactHtml = `
        <p style="margin-top:15px;">
          Contact <b>${apiRes[0].firstname} ${apiRes[0].lastname}</b> 
          at <b>${apiRes[0].emailaddr}</b>
        </p>
      `;
            }

            Swal.fire({
              icon: "warning",
              html: `
        <div style="text-align:center; font-size:15px;">
          <p>
        <b>Security information :</b> You have not logged into the system for
        more than <b>THREE</b> months. Your account is now locked.
        Please contact your Administrator to unlock it.
      </p>

          ${contactHtml}

          <p style="margin-top:10px;">
          You can also contact <b>Subhashree Panda</b><br>
          (subhashree.panda@complinity.com) at Complinity</p>
        </div>
      `
            });

          });
        }


        else if (res.response == 'changepassword') {
          const ref = this.dialogService.open(ChangepasswordComponent, {
            header: "Change Password",
            height: 'auto',
            width: '30%',
            data: { userid: this.loginForm.get('useremail').value }
          });
          ref.onClose.subscribe(res => {
            console.log(res);

            if (res.response == 'Save') {
              this.loginForm.patchValue({ userpassword: res.password })
              this.login()
            }
          })

        }
        else if (res.response == 'mandatorypasswordchange') {
          this.spinnerservice.show()
          this.loginservice.sendotpforpassword( { email: this.loginForm.get('useremail').value }).subscribe(res=>{
                      this.spinnerservice.hide()

            if(res){
               const ref = this.dialogService.open(ChanagepasswordwithOTPComponent, {
            header: "Change Password",
            height: 'auto',
            width: '60%',
            data: { userid: this.loginForm.get('useremail').value,securitycode:res.message }
          })
            }
          },error=>{
                      this.spinnerservice.hide();
                      Swal.fire({ icon: "error", title: error.error.message});

          })
        
        }
        else if (res.response == 'outsidefirewall') {
          Swal.fire({
            icon: "warning",
            title: "You are trying to access from outside your Organisation's firewall. Access is not allowed as per your Organisation's security policy."
          });

        }
        else if (res.response == 'orgurlnotmatching') {
          Swal.fire({
            icon: "warning",
            title: "Your credentials are not matching with organisation's URL. Please check Complinity URL"
          })
        } else if (res.response == 'logintypssomismatch') {
          Swal.fire({
            icon: "warning",
            title: "Your organisation has opted for SSO/AD login but you are trying to login through DB credentials, which is prohibited. Please Login using your SSO/AD login machanism or contact your organisation Administrator. "
          })
        }
        else if (res.response == 'wronglogin') {

          this.loginservice.getadmindetailsforcontact({
            emailaddress: this.loginForm.value.useremail
          }).subscribe(apiRes => {

            let contactHtml = '';
            if (apiRes && apiRes.length > 0) {
              contactHtml = `
        <p style="margin-top:15px;">
          Contact <b>${apiRes[0].firstname} ${apiRes[0].lastname}</b> 
          at <b>${apiRes[0].emailaddr}</b>
        </p>
      `;
            }

            Swal.fire({
              icon: "warning",
              html: `
        <div style="text-align:center; font-size:15px;">
          <p>
            <b>Security information :</b> Your login has failed more than the allowed maximum limit. 
            Your account is now locked. Please contact your Administrator to unlock it.
          </p>

          ${contactHtml}

          <p style="margin-top:10px;">
          You can also contact <b>Subhashree Panda</b><br>
          (subhashree.panda@complinity.com) at Complinity</p>
        </div>
      `
            });

          });
        }

        else if (res.response == 'failed') {
          Swal.fire({
            icon: "error",
            title: "Wrong Email ID or Password",
            text: "Please check your credentials",
            confirmButtonText: "OK",
            confirmButtonColor: "#011061",
            //  width: "300px",
            //   padding: "0.8em",
            showClass: {
              icon: ''
            },
            customClass: {
              icon: 'small-swal-icon',
              //      popup: "login-swal",
              //  title: "login-swal-title"
            }
          })
        }

        else {
          Swal.fire({
            icon: "error",
            title: "Wrong Email ID or Password",
            text: "Please check your credentials",
            confirmButtonText: "OK",
            confirmButtonColor: "#011061",
            // width: "300px",
            // padding: "0.8em",
            showClass: {
              icon: ''
            },
            customClass: {
              icon: 'small-swal-icon',
              //      popup: "login-swal",
              //  title: "login-swal-title"

            }
          });
        }
      });
    }

  }
  relogin(repayload) {
      // const email = this.activateroute.snapshot.queryParamMap.get('email');    
    if (this.loginForm.invalid) {
      this.validateAllFormFields(this.loginForm)
      return
    }
    else {
      let payload={}

       payload = repayload;
       
      //  {
      //   userid: this.loginForm.get('useremail').value, password: this.loginForm.get('userpassword').value, "isadauth": "DB",
      //   "isssologin": "","newlogin": "N"

      // }
      const encryptdata = this.utilityservice.encryptData(payload);
      this.spinnerservice.show()
      this.loginservice.doLogin(encryptdata).subscribe(res => {
        this.spinnerservice.hide()

        if (res && res.response == 'success') {
          const result = res.userdata
          if (res.userdata.issupportadmin == 'Y') {
            Swal.fire({
              title: "It seems you are logging as Support Admin",
              text: 'To do the above, we alse require your real userid & password for security reasons.',
              showCancelButton: true,
              confirmButtonText: "Login",
              confirmButtonColor: 'rgb(221, 107, 85)',
              cancelButtonColor: 'grey',
              cancelButtonText: 'Cancel',
              icon: 'info',
              iconColor: 'rgb(221, 107, 85)'
            }).then((value) => {
              if (value.isConfirmed) {
                const ref = this.dialogService.open(SupportverificationcationmodalComponent, {
                  header: "Logged in  Security Information",
                  height: 'auto',
                  width: '50%',
                  data: { logindata: res.userdata }
                })
              }
            })

          }
          else if (res.userdata.ismfaenabled == 'Y') {
            this.openOtpwindow(res.userdata)
          }
          else {
           
            const ref = this.dialogService.open(LoginsecuritymodalComponent, {
              header: "Logged in  Security Information",
              style: { 
    width: '90vw', 
    'max-width': '800px' 
  },
    styleClass: 'scroll-dialog',

              data: { loginid: res.userdata.userid,email :this.loginForm.get('useremail').value}
            })
            ref.onClose.subscribe(() => {
              const data = JSON.stringify(res.userdata);
              localStorage.setItem('userdata', data);
              const loginTime = new Date().toISOString(); // or just new Date()
              localStorage.setItem('loginTime', loginTime);
              window.location.href = location.origin + res.userdata.defaultpagemircroservice + "#/"
            });

          }

        }
        // condition based swal message  ---11-02-2025
        else if (res.response == 'organisationsuspended') {
          Swal.fire({
            icon: "warning",
            title: "Your organisation's license is temporarily suspended. Please contact your organisation Administrator or Complinity Support.",
          });

        }
        else if (res.response == 'organisationsuspended') {
          `${this.loginForm.get('useremail').value} is already logged in from the same account`
          Swal.fire({
            icon: "warning",
            title: `${this.loginForm.get('useremail').value} is already logged in from the same account`,
          });
        }
        else if (res.response == 'multiplelogin') {
          Swal.fire({
            text: "This could be because you have closed the browser without logging out or internet connection broke while using the application. Kindly click Send OTP (One Time Password) button to receive email. Enter OTP to login (in popup screen) else account will be automatically enabled after 30 minutes.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Send OTP',
            cancelButtonText: "No, cancel it!",

          });
        }
        else if (res.response == 'locked') {

          this.loginservice.getadmindetailsforcontact({
            emailaddress: this.loginForm.value.useremail
          }).subscribe(apiRes => {

            let contactHtml = '';
            if (apiRes && apiRes.length > 0) {
              contactHtml = `
        <p style="margin-top:15px;">
          Contact <b>${apiRes[0].firstname} ${apiRes[0].lastname}</b> 
          at <b>${apiRes[0].emailaddr}</b>
        </p>
      `;
            }

            Swal.fire({
              icon: "warning",
              html: `
        <div style="text-align:center; font-size:15px;">
          <p>
            <b>Security information :</b> Your login has failed more than the allowed maximum limit. 
            Your account is now locked. Please contact your Administrator to unlock it.
          </p>

          ${contactHtml}

          <p style="margin-top:10px;">
          You can also contact <b>Subhashree Panda</b><br>
          (subhashree.panda@complinity.com) at Complinity</p>
        </div>
      `
            });

          });
        }

        else if (res.response == '3monthlock') {

          this.loginservice.getadmindetailsforcontact({
            emailaddress: this.loginForm.value.useremail
          }).subscribe(apiRes => {

            let contactHtml = '';
            if (apiRes && apiRes.length > 0) {
              contactHtml = `
        <p style="margin-top:15px;">
          Contact <b>${apiRes[0].firstname} ${apiRes[0].lastname}</b> 
          at <b>${apiRes[0].emailaddr}</b>
        </p>
      `;
            }

            Swal.fire({
              icon: "warning",
              html: `
        <div style="text-align:center; font-size:15px;">
          <p>
        <b>Security information :</b> You have not logged into the system for
        more than <b>THREE</b> months. Your account is now locked.
        Please contact your Administrator to unlock it.
      </p>

          ${contactHtml}

          <p style="margin-top:10px;">
          You can also contact <b>Subhashree Panda</b><br>
          (subhashree.panda@complinity.com) at Complinity</p>
        </div>
      `
            });

          });
        }


        else if (res.response == 'changepassword') {
          const ref = this.dialogService.open(ChangepasswordComponent, {
            header: "Change Password",
            height: 'auto',
            width: '30%',
            data: { userid: this.loginForm.get('useremail').value }
          });
          ref.onClose.subscribe(res => {
            console.log(res);

            if (res.response == 'Save') {
              this.loginForm.patchValue({ userpassword: res.password })
              this.login()
            }
          })

        }
        else if (res.response == 'mandatorypasswordchange') {
          this.spinnerservice.show()
          this.loginservice.sendotpforpassword( { email: this.loginForm.get('useremail').value }).subscribe(res=>{
                      this.spinnerservice.hide()

            if(res){
               const ref = this.dialogService.open(ChanagepasswordwithOTPComponent, {
            header: "Change Password",
            height: 'auto',
            width: '60%',
            data: { userid: this.loginForm.get('useremail').value,securitycode:res.message }
          })
            }
          },error=>{
                      this.spinnerservice.hide();
                      Swal.fire({ icon: "error", title: error.error.message});

          })
        
        }
        else if (res.response == 'outsidefirewall') {
          Swal.fire({
            icon: "warning",
            title: "You are trying to access from outside your Organisation's firewall. Access is not allowed as per your Organisation's security policy."
          });

        }
        else if (res.response == 'orgurlnotmatching') {
          Swal.fire({
            icon: "warning",
            title: "Your credentials are not matching with organisation's URL. Please check Complinity URL"
          })
        } else if (res.response == 'logintypssomismatch') {
          Swal.fire({
            icon: "warning",
            title: "Your organisation has opted for SSO/AD login but you are trying to login through DB credentials, which is prohibited. Please Login using your SSO/AD login machanism or contact your organisation Administrator. "
          })
        }
        else if (res.response == 'wronglogin') {

          this.loginservice.getadmindetailsforcontact({
            emailaddress: this.loginForm.value.useremail
          }).subscribe(apiRes => {

            let contactHtml = '';
            if (apiRes && apiRes.length > 0) {
              contactHtml = `
        <p style="margin-top:15px;">
          Contact <b>${apiRes[0].firstname} ${apiRes[0].lastname}</b> 
          at <b>${apiRes[0].emailaddr}</b>
        </p>
      `;
            }

            Swal.fire({
              icon: "warning",
              html: `
        <div style="text-align:center; font-size:15px;">
          <p>
            <b>Security information :</b> Your login has failed more than the allowed maximum limit. 
            Your account is now locked. Please contact your Administrator to unlock it.
          </p>

          ${contactHtml}

          <p style="margin-top:10px;">
          You can also contact <b>Subhashree Panda</b><br>
          (subhashree.panda@complinity.com) at Complinity</p>
        </div>
      `
            });

          });
        }

        else if (res.response == 'failed') {
          Swal.fire({
            icon: "error",
            title: "Wrong Email ID or Password",
            text: "Please check your credentials",
            confirmButtonText: "OK",
            confirmButtonColor: "#011061",
            //  width: "300px",
            //   padding: "0.8em",
            showClass: {
              icon: ''
            },
            customClass: {
              icon: 'small-swal-icon',
              //      popup: "login-swal",
              //  title: "login-swal-title"
            }
          })
        }

        else {
          Swal.fire({
            icon: "error",
            title: "Wrong Email ID or Password",
            text: "Please check your credentials",
            confirmButtonText: "OK",
            confirmButtonColor: "#011061",
            // width: "300px",
            // padding: "0.8em",
            showClass: {
              icon: ''
            },
            customClass: {
              icon: 'small-swal-icon',
              //      popup: "login-swal",
              //  title: "login-swal-title"

            }
          });
        }
      });
    }

  }
  invalidssologin=false
  ssologin() {  
    // this.getsessiontoken();
    // timer(2000).subscribe(() => {    
    this.loginservice.sessiontoken().subscribe({
    next: (res: any) => {
      console.log(res);

      if (res?.response?.length > 0) {
        this.sessiontoken = res.response[0].pagetoken;

        localStorage.setItem('pagetoken', this.sessiontoken);
        this.sessiondata.next(this.sessiontoken);

        console.log('Token:', this.sessiontoken);
         const emailid=this.activateroute.snapshot.queryParamMap.get('param').replace(/'/g, '') 
    if(emailid=='invalid'){
      this.invalidssologin=true;
   Swal.fire({
            icon: "warning",
            title: "We are not able to fetch your email details from received token. Please try again later or contact to administrator.",
          });
    }else{
     
    
   const payload = {
        userid: this.activateroute.snapshot.queryParamMap.get('param').replace(/'/g, ''),
        password: "",
        "isadauth": "SSO",
        "isssologin": "ssoxlogin",
        "newlogin": "Y",
        "pagetoken":this.sessiontoken
      }
      const encryptdata = this.utilityservice.encryptData(payload);
      this.spinnerservice.show()
      this.loginservice.doLogin(encryptdata).subscribe(res => {
        this.spinnerservice.hide()

        if (res && res.response == 'success') {
          const result = res.userdata
          if (res.userdata.issupportadmin == 'Y') {
            Swal.fire({
              title: "It seems you are logging as Support Admin",
              text: 'To do the above, we alse require your real userid & password for security reasons.',
              showCancelButton: true,
              confirmButtonText: "Login",
              confirmButtonColor: 'rgb(221, 107, 85)',
              cancelButtonColor: 'grey',
              cancelButtonText: 'Cancel',
              icon: 'info',
              iconColor: 'rgb(221, 107, 85)'
            }).then((value) => {
              if (value.isConfirmed) {
                const ref = this.dialogService.open(SupportverificationcationmodalComponent, {
                  header: "Logged in  Security Information",
                  height: 'auto',
                  width: '50%',
                  data: { logindata: res.userdata }
                })
              }
            })

          }
          else if (res.userdata.ismfaenabled == 'Y') {
            this.openOtpwindow(res.userdata)
          }
          else {
           
            const ref = this.dialogService.open(LoginsecuritymodalComponent, {
              header: "Logged in  Security Information",
              style: { 
    width: '90vw', 
    'max-width': '800px'   // ✅ max width limit
  },
  contentStyle: {
    'max-height': '70vh',
    'overflow-y': 'auto',
    'overflow-x': 'auto'
  },
              data: { loginid: res.userdata.userid,email :this.loginForm.get('useremail').value }
            })
            ref.onClose.subscribe(() => {
              const data = JSON.stringify(res.userdata);
              localStorage.setItem('userdata', data);
              const loginTime = new Date().toISOString(); // or just new Date()
              localStorage.setItem('loginTime', loginTime);
              window.location.href = location.origin + res.userdata.defaultpagemircroservice + "#/"
            });

          }

        }
        // condition based swal message  ---11-02-2025
        else if (res.response == 'organisationsuspended') {
          Swal.fire({
            icon: "warning",
            title: "Your organisation's license is temporarily suspended. Please contact your organisation Administrator or Complinity Support.",
          });

        }
        else if (res.response == 'organisationsuspended') {
          `${this.loginForm.get('useremail').value} is already logged in from the same account`
          Swal.fire({
            icon: "warning",
            title: `${this.loginForm.get('useremail').value} is already logged in from the same account`,
          });
        }
        else if (res.response == 'multiplelogin') {
          Swal.fire({
            text: "This could be because you have closed the browser without logging out or internet connection broke while using the application. Kindly click Send OTP (One Time Password) button to receive email. Enter OTP to login (in popup screen) else account will be automatically enabled after 30 minutes.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Send OTP',
            cancelButtonText: "No, cancel it!",

          });
        }


        else if (res.response == 'locked') {

          this.loginservice.getadmindetailsforcontact({
            emailaddress: this.loginForm.value.useremail
          }).subscribe(apiRes => {

            let contactHtml = '';
            if (apiRes && apiRes.length > 0) {
              contactHtml = `
        <p style="margin-top:15px;">
          Contact <b>${apiRes[0].firstname} ${apiRes[0].lastname}</b> 
          at <b>${apiRes[0].emailaddr}</b>
        </p>
      `;
            }

            Swal.fire({
              icon: "warning",
              html: `
        <div style="text-align:center; font-size:15px;">
          <p>
            <b>Security information :</b> Your login has failed more than the allowed maximum limit. 
            Your account is now locked. Please contact your Administrator to unlock it.
          </p>

          ${contactHtml}

          <p style="margin-top:10px;">
          You can also contact <b>Subhashree Panda</b><br>
          (subhashree.panda@complinity.com) at Complinity</p>
        </div>
      `
            });

          });
        }

        else if (res.response == '3monthlock') {

          this.loginservice.getadmindetailsforcontact({
            emailaddress: this.loginForm.value.useremail
          }).subscribe(apiRes => {

            let contactHtml = '';
            if (apiRes && apiRes.length > 0) {
              contactHtml = `
        <p style="margin-top:15px;">
          Contact <b>${apiRes[0].firstname} ${apiRes[0].lastname}</b> 
          at <b>${apiRes[0].emailaddr}</b>
        </p>
      `;
            }

            Swal.fire({
              icon: "warning",
              html: `
        <div style="text-align:center; font-size:15px;">
          <p>
        <b>Security information :</b> You have not logged into the system for
        more than <b>THREE</b> months. Your account is now locked.
        Please contact your Administrator to unlock it.
      </p>

          ${contactHtml}

          <p style="margin-top:10px;">
          You can also contact <b>Subhashree Panda</b><br>
          (subhashree.panda@complinity.com) at Complinity</p>
        </div>
      `
            });

          });
        }


        else if (res.response == 'changepassword') {
          const ref = this.dialogService.open(ChangepasswordComponent, {
            header: "Change Password",
            height: 'auto',
            width: '30%',
            data: { userid: this.loginForm.get('useremail').value }
          });
          ref.onClose.subscribe(res => {
            console.log(res);

            if (res.response == 'Save') {
              this.loginForm.patchValue({ userpassword: res.password })
              this.login()
            }
          })

        }
       
        else if (res.response == 'outsidefirewall') {
          Swal.fire({
            icon: "warning",
            title: "You are trying to access from outside your Organisation's firewall. Access is not allowed as per your Organisation's security policy."
          });

        }
        else if (res.response == 'orgurlnotmatching') {
          Swal.fire({
            icon: "warning",
            title: "Your credentials are not matching with organisation's URL. Please check Complinity URL"
          })
        } else if (res.response == 'logintypssomismatch') {
          Swal.fire({
            icon: "warning",
            title: "Your organisation has opted for SSO/AD login but you are trying to login through DB credentials, which is prohibited. Please Login using your SSO/AD login machanism or contact your organisation Administrator. "
          })
        }
        else if (res.response == 'wronglogin') {

          this.loginservice.getadmindetailsforcontact({
            emailaddress: this.loginForm.value.useremail
          }).subscribe(apiRes => {

            let contactHtml = '';
            if (apiRes && apiRes.length > 0) {
              contactHtml = `
        <p style="margin-top:15px;">
          Contact <b>${apiRes[0].firstname} ${apiRes[0].lastname}</b> 
          at <b>${apiRes[0].emailaddr}</b>
        </p>
      `;
            }

            Swal.fire({
              icon: "warning",
              html: `
        <div style="text-align:center; font-size:15px;">
          <p>
            <b>Security information :</b> Your login has failed more than the allowed maximum limit. 
            Your account is now locked. Please contact your Administrator to unlock it.
          </p>

          ${contactHtml}

          <p style="margin-top:10px;">
          You can also contact <b>Subhashree Panda</b><br>
          (subhashree.panda@complinity.com) at Complinity</p>
        </div>
      `
            });

          });
        }

        else if (res.response == 'failed') {
          Swal.fire({
            icon: "error",
            title: "Wrong Email ID or Password",
            text: "Please check your credentials",
            confirmButtonText: "OK",
            confirmButtonColor: "#011061",
            //  width: "300px",
            //   padding: "0.8em",
            showClass: {
              icon: ''
            },
            customClass: {
              icon: 'small-swal-icon',
              //      popup: "login-swal",
              //  title: "login-swal-title"
            }
          })
        }

        else {
          Swal.fire({
            icon: "error",
            title: "Wrong Email ID or Password",
            text: "Please check your credentials",
            confirmButtonText: "OK",
            confirmButtonColor: "#011061",
            // width: "300px",
            // padding: "0.8em",
            showClass: {
              icon: ''
            },
            customClass: {
              icon: 'small-swal-icon',
              //      popup: "login-swal",
              //  title: "login-swal-title"

            }
          });
        }
      });
    
    }
      }

    },
    error: (err) => {
      console.error('Error fetching token', err);
    }
  });
   
    // });
  }
  gettoken(): string {
    this.userdata = this.loginservice.getLoggeduser();
    return this.userdata.token;
  }
  passwordcrypt() {
    let ciphertext = CryptoJS.AES.encrypt('my message', 'secret key 123').toString();
    // Decrypt
    let bytes = CryptoJS.AES.decrypt(ciphertext, 'secret key 123');
    let originalText = bytes.toString(CryptoJS.enc.Utf8);
  }
  uniquekey = ''

  encryptpassword(): Promise<string> {
    return new Promise((resolve, reject) => {
      let uniqueKey: string;
      this.uniquekey = ''
      // Get unique key
      this.loginservice.getUniqueKey()
        .then((res: string) => {
          uniqueKey = res;
          this.uniquekey = res
          const iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
          const salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);

          const keySize = 128;
          const iterations = 1000;

          // Create AES key
          const key = CryptoJS.PBKDF2(uniqueKey, CryptoJS.enc.Hex.parse(salt), {
            keySize: keySize / 32,
            iterations: iterations
          });

          // Encrypt password
          const ciphertext = CryptoJS.AES.encrypt(this.loginForm.get('userpassword').value, key, {
            iv: CryptoJS.enc.Hex.parse(iv),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
          }).toString();
          const aesPassword = iv + ":slc:" + salt + ":slc:" + ciphertext;

          // Convert to base64
          const password = btoa(aesPassword);
          console.log("iv:", iv);
          console.log("salt:", salt);
          console.log("ciphertext:", ciphertext);
          console.log("uniqkey:", uniqueKey);
          console.log(password);
          resolve(password);
        })
        .catch((error: any) => {
          console.error(error);
          reject(error);
        });
    });
  }
  decryptPassword(encryptedPassword: string, uniqueKey: string): string {
    // Split the encrypted password into its components
    const parts = atob(encryptedPassword).split(':slc:');
    const iv = parts[0];
    const salt = parts[1];
    const ciphertext = parts[2];

    const keySize = 128;
    const iterations = 1000;

    // Recreate AES key using the same unique key and salt
    const key = CryptoJS.PBKDF2(uniqueKey, CryptoJS.enc.Hex.parse(salt), {
      keySize: keySize / 32,
      iterations: iterations
    });

    // Decrypt the ciphertext
    const decrypted = CryptoJS.AES.decrypt(ciphertext, key, {
      iv: CryptoJS.enc.Hex.parse(iv),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    console.log(decrypted.toString(CryptoJS.enc.Utf8), "password after decrypt");

    return decrypted.toString(CryptoJS.enc.Utf8);
  }
  isCaptcha: boolean = false
  validcaptcha() {
    if (this.loginForm.get("useremail").value == '') {
      Swal.fire("Enter User Email Address", "", "info").then(() => {
        setTimeout(() => {
          this.userEmailInput.nativeElement.focus();
        }, 10);
      })
    } else {
      const payload = {
        "userid": this.loginForm.get("useremail").value,
        "password": "",
        "forwardpage": ""
      }
      this.spinnerservice.show();
      this.loginservice.forgotpassword(payload).subscribe(res => {
        this.spinnerservice.hide();
        if (res.response == 'success') {
          Swal.fire("A Password Reset link has been sent to your Email Inbox", "Please check and change your password", "success")
        }
        else {
          Swal.fire(res.message, "Please contact to administrator", "warning")

        }
      }, error => {
        Swal.fire(error.error.message, '', 'error');
      })

    }

  }
  resetPassword() {
    this.isCaptcha = true

  }
  ismfenable = false
  resetpasswderror = false
  openCaptcha(ismfenable, titel) {
    // this.loginForm.get('userpassword').clearValidators();
    // this.loginForm.updateValueAndValidity()
    const passwordControl = this.loginForm.get('userpassword');

    passwordControl.clearValidators();
    passwordControl.setErrors(null);
    passwordControl.markAsPristine();
    passwordControl.markAsUntouched();
    passwordControl.updateValueAndValidity();
    if (this.loginForm.get('useremail').invalid) {
      this.validateAllFormFields(this.loginForm);
      return;
      // this.resetpasswderror=true
    }
    // if(this.loginForm.get('useremail').value!=='' && this.loginForm.get('useremail').value!==undefined && this.loginForm.get('useremail').value!==null)
    else {
      const ref = this.dialogService.open(CaptchaComponent, {
        header: titel,
        height: 'auto',
        width: '40%',
        data: { IsMFAuser: ismfenable }
      });
      ref.onClose.subscribe((res) => {
        console.log(res, "res");

        if (res == "validcaptcha") {
          this.validcaptcha()
        }
        else if (res == 'validotp') {


        }
      })
    }

  }
  openOtpwindow(userdata) {
    const ref = this.dialogService.open(OtpInputComponent, {
      header: "Enter OTP",
      height: '35%',
      width: '40%',
      data: { fromvalue: userdata }
    });
    ref.onClose.subscribe((res) => {
      if (res == 'validotp') {
        const ref = this.dialogService.open(LoginsecuritymodalComponent, {
          header: "Logged in  Security Information",
          height: 'auto',
          width: '50%',
          data: { loginid: userdata.userid ,email :this.loginForm.get('useremail').value}
        })
        ref.onClose.subscribe(() => {
          const data = JSON.stringify(userdata);
          localStorage.setItem('userdata', data);
          const loginTime = new Date().toISOString(); // or just new Date()
          localStorage.setItem('loginTime', loginTime);
          window.location.href = location.origin + userdata.defaultpagemircroservice + "#/"
        });


      }
    })
  }

  resetIdleTimer() {

    this.idle.watch();
  }

  showTimeoutSwal() {
    let seconds = 10; // countdown seconds
    let interval: any;

    Swal.fire({
      title: 'This screen is idle for more than 30 minutes',
      html: 'No activity detected.',
      icon: 'warning',
      confirmButtonText: 'OK',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: true,

      didOpen: () => {
        const b = Swal.getHtmlContainer()?.querySelector('b');

        interval = setInterval(() => {
          seconds--;


          // stop countdown at 0 (DO NOT close)
          if (seconds === 0) {
            clearInterval(interval);
          }

        }, 1000);
      },

      willClose: () => {
         clearInterval(interval);
      }

    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload(); // refresh only on OK
      }
    });
  }
  playBeep() {
    const ctx = new AudioContext();
    const oscillator = ctx.createOscillator();
    const gain = ctx.createGain();

    oscillator.frequency.value = 700;
    oscillator.type = 'square';

    oscillator.connect(gain);
    gain.connect(ctx.destination);

    oscillator.start();
    oscillator.stop(ctx.currentTime + 0.15);
  }
ssoenable=false
  redirect(host) {
    console.log(host);
console.log("link:"+this.ssoredirectlink);
console.log("link metadata:"+this.ssolinkmetadata);
  
    if (this.ssoredirectlink !== undefined && this.ssoredirectlink !=='') {
      if (this.ssolinkmetadata !=null && this.ssolinkmetadata !='') {
      this.autoredirect(this.ssolinkmetadata,this.ssoredirectlink);
      }else{
      // window.location.replace(this.ssoredirectlink)
      //  window.location.href = this.ssoredirectlink; 
      }
       }

  }
ssologinredirect(){
  this.sessiondata.subscribe(res=>{
        localStorage.setItem('pagetoken', this.sessiontoken);
        window.location.replace(this.ssoredirectlink);
  })

}
  autoredirect(metadatastring,link){
    const metadata = metadatastring;

  const form = document.createElement("form");
  form.method = "POST";
  form.action = link;

  const input = document.createElement("input");
  input.type = "hidden";
  input.name = "SAMLRequest";
  input.value = metadata;

  form.appendChild(input);
  document.body.appendChild(form);
  form.submit();
  }


}
